import { useState, type FormEvent } from "react";
import { tEnglish as t } from "@buza/i18n";
import { api } from "../api.js";

// S01 Forgot password (S-008; SEC-06). The api gives the same answer whether or not the address
// has an account, so this screen shows one confirmation for every accepted request. Screens are
// paused (4 Nov 2026): minimal, accessible, phrase keys only; it moves onto the ZD shell later.

const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export function ForgotPassword({ onBack }: { onBack: () => void }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [fieldError, setFieldError] = useState<string | undefined>();
  const [sent, setSent] = useState<string | undefined>();

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!EMAIL.test(email.trim())) {
      setError(undefined);
      setFieldError(t("auth.signin.email_invalid"));
      return;
    }
    setBusy(true);
    const r = await api<{ message: string }>("/v1/parlour/password/reset", { method: "POST", body: { email: email.trim() } });
    setBusy(false);
    if (r.ok) {
      setSent(r.data.message);
      return;
    }
    setFieldError(r.error?.fields?.email);
    setError(r.status === 0 ? t("common.errors.no_connection") : r.error?.code === "VALIDATION" ? undefined : (r.error?.message ?? t("common.errors.validation")));
  }

  return (
    <main className="s01">
      <h1>{t("parlour.shell.app_name")}</h1>
      <h2>{t("parlour.reset.title")}</h2>
      {sent ? (
        <p role="status">{sent}</p>
      ) : (
        <>
          <p>{t("parlour.reset.intro")}</p>
          {error && (
            <p role="alert" className="error">
              {error}
            </p>
          )}
          <form onSubmit={submit} noValidate aria-label={t("parlour.reset.title")}>
            <label>
              {t("parlour.signin.email_label")}
              <input
                type="email"
                name="email"
                autoComplete="username"
                required
                maxLength={254}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-invalid={!!fieldError}
              />
            </label>
            {fieldError && <p className="field-error">{fieldError}</p>}
            <button type="submit" disabled={busy}>
              {busy ? t("parlour.reset.working") : t("parlour.reset.submit")}
            </button>
          </form>
        </>
      )}
      <p>
        <button type="button" onClick={onBack}>
          {t("parlour.reset.back")}
        </button>
      </p>
    </main>
  );
}
